import React from 'react';
import styled from 'styled-components';
import { colors } from '../theme/ColorTheme';
import mediaQ from '../theme/responsive';
import ReactHtmlParser from 'react-html-parser';

export default class SimpleBubble extends React.Component {
    render() {
        const { toolTipText, markerValue } = this.props;

   
        return (
            <React.Fragment>
                <Bubble>
                    {markerValue}
                    <ToolTip>
                        <ToolTipList>
                            {toolTipText}
                        </ToolTipList>
                        <Arrow />
                    </ToolTip>
                </Bubble>
            </React.Fragment>
        );
    }
}

const Arrow = styled.i`
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -12px;
    width: 24px;
    height: 12px;
    overflow: hidden;
    &::after {
        content: '';
        position: absolute;
        width: 12px;
        height: 12px;
        left: 50%;
        transform: translate(-50%, 50%) rotate(45deg);
        background-color: ${colors.white};
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
    }
`;

const ToolTipList = styled.ul``;

const ToolTipListItem = styled.li`
    padding: 0.75rem 1rem;
    line-height: 1.5em;

    &:nth-child(even) {
        background: rgba(0, 0, 0, 0.05);
    }
`;

const ToolTip = styled.div`
    color: ${colors.black};
    background-color: ${colors.white};
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
    display: none;
    top: 40px;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 0.8667rem;
    position: absolute;
    min-width: 250px;
    z-index: 99;
    ${mediaQ.phone`
        min-width: 130px;
        font-size: 80%;
        padding: 2px 5px;
    `}
`;

const Bubble = styled.div`
    height: 22px;
    width: 22px;
    background-color ${colors.projectLightBlue};
    position: absolute;
    display: inline-block;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.white};
    &:hover {
        ${ToolTip}{
            display: block;
        }
    }
`;
